<template>
    <div class="container">
        <div class="row mt-4">
            <titleArea :title="this.$t('menus.pa.chief_prosecutor.title1')" />
            <div class="col sm-12 col-md-8 col-lg-5">
                <ProfileCard
                    :title="persecutor_chief.title"
                    :avatar="persecutor_chief.img"
                    :fullname="persecutor_chief.fullname"
                    :position="persecutor_chief.position"
                    :birthday="persecutor_chief.birthday"
                    :address="persecutor_chief.address"
                    :cv_text="persecutor_chief.cv_text"
                    facebook="#"
                    @primary="pranoFunksioni"
                    @secondary="anuloFunksioni" />
            </div>
        </div>
    </div>
</template>

<script>
import ProfileCard from '../share/PresecutorChiefTemplate.vue'
import titleArea from '../../components/share/TitleArea.vue'

export default {
    data() {
        return {
            persecutor_chief: {
                title:this.$t('menus.pa.chief_prosecutor.title1'),
                img:require('@/assets/AllSystem/zkpsh/BesimKelmendi.png'),
                fullname: "Besim S.Kelmendi",
                position: this.$t('menus.pa.chief_prosecutor.title1'),
                birthday: "21.03.1962",
                address: "Prishtine",
                cv_text: `TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI `, // CV përshkrimi
            }
        }
    },
    components: {
        ProfileCard,
        titleArea
    },
    methods: {
        pranoFunksioni() { console.log("Pranoj") },
        anuloFunksioni() { console.log("Mbyll") }
    }
}
</script>
